module.exports = __webpack_public_path__ + "img/portfolio-1.c09bb550.jpg";